import { isCMHK } from '@fs/utils'
import CMHKLogoutInstance from '@/utils/CMHKLogout'
import { Toast } from 'vant'
import { i18n } from '@/i18n/login'
import MYLINK_JSBRIDGE from '@fs/jsbridge/dist/lib/mylinkJsBridge'

export default ({ store } = {}) =>
    response => {
        if (isCMHK()) {
            // 中移动
            switch (response.data?.error?.code) {
                case 100034:
                    // 互踢弹窗
                    CMHKLogoutInstance.open()
                    return Promise.reject(response)
                case 100008:
                case 100033:
                    Toast({
                        forbidClick: true,
                        message: i18n.t('requestCode.dlsxqcxdl'),
                        onClose: () => {
                            // session失效关闭webview
                            MYLINK_JSBRIDGE.backToHomePage()
                            store.dispatch('user/clearUserInfo')
                        },
                    })
                    return Promise.reject(response)
                default:
                    break
            }
        }
        return response
    }
